var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"y-slide","mode":"out-in"}},[_c('div',{key:_vm.masonryCardData.length},[_c('MasonryCards',{attrs:{"content":_vm.masonryCardData},on:{"bodyClick":_vm.goToSite}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }